import { TrainingBrand } from '../models';
import { ISubCategory } from '../pages/core/components/trainings-list/components/trainings-categories/trainings-categories.component';

const lorealProfessionnelCategoriesIds: number[] = [1, 2, 3, 4, 5, 6, 7];
const redkenCategoriesIds: number[] = [1, 2, 3, 5, 6];
const kerastaseCategoriesIds: number[] = [2, 6, 8];
export function categoriesFilterByBrand(
  categories: ISubCategory[],
  brand: TrainingBrand | null = null,
): ISubCategory[] {
  switch (brand) {
    case TrainingBrand.KERASTASE:
      return categories.filter((c: ISubCategory) => {
        return !!kerastaseCategoriesIds.find((el: number) => el === c.categoryId);
      });
    case TrainingBrand.LOREAL_PROFESSIONNEL:
      return categories.filter((c: ISubCategory) => {
        return !!lorealProfessionnelCategoriesIds.find((el: number) => el === c.categoryId);
      });
    case TrainingBrand.REDKEN:
      return categories.filter((c: ISubCategory) => {
        return !!redkenCategoriesIds.find((el: number) => el === c.categoryId);
      });
    default:
      return categories;
  }
}
